import React from 'react';
import { Redirect, RouteProps } from 'react-router-dom';
import { arePageFlagsPending, EventSettingsContextType, useEventSettings } from '../../../lib/context-providers/event-settings-context/event-settings-context';
import { EmbedContainer } from '../../../lib/kv-embed';
import isEnabledRoute from '../../../hooks/use-enabled-route';

type ShowcaseWrapperProps = {
  location: {
    state: { showcasePagePath: string } | null
  } & Partial<RouteProps>
};

const ShowcaseWrapper: React.FC<ShowcaseWrapperProps> = ({ location }: ShowcaseWrapperProps): JSX.Element | null => {
  const pagePath = location?.state?.showcasePagePath ?? '';
  const eventSettings = useEventSettings() as EventSettingsContextType;
  const enabledRoute = isEnabledRoute(eventSettings?.landingPage);

  if (!eventSettings || arePageFlagsPending(eventSettings)) return null;

  if (!eventSettings.showcaseEnabled) {
    return <Redirect to={enabledRoute} />;
  }

  const embedId = eventSettings.showcaseEmbedId || null;

  return <EmbedContainer.Showcase embedId={embedId} pagePath={pagePath}/>;
};

export default ShowcaseWrapper;
